import { User, UserSettings, UserSettingsErrors } from '../types';
import { oktaClient as api, partnerClient } from '.';
import { AxiosError } from 'axios';

export const getCurrentUser = async (): Promise<User | undefined> => {
  return await api.get('/users/me');
};

export const updateCurrentUser = async (payload: Partial<User>): Promise<User | undefined> => {
  return await api.post('/users/me', payload);
};

export const getUserSettings = async (userId: string): Promise<UserSettings | undefined> => {
  try {
    return await partnerClient.get(`/users/${userId}/settings`);
  } catch (err: unknown) {
    const error = err as AxiosError;
    // handle 404 when users settings does NOT exist for the user.
    if (error.response?.status === 404) {
      throw new Error(UserSettingsErrors.NOT_FOUND);
    }
  }
};

export const updateUserSettings = async (
  userId: string,
  payload: Partial<UserSettings>,
): Promise<UserSettings | undefined> => {
  return await partnerClient.patch(`/users/${userId}/settings`, payload);
};

export const insertUserSettings = async (
  userId: string,
  payload: Partial<UserSettings>,
): Promise<UserSettings | undefined> => {
  return await partnerClient.post(`/users/${userId}/settings`, payload);
};

export const upsertUserSettings = async (
  isNew: boolean,
  userId: string,
  payload: Partial<UserSettings>,
): Promise<UserSettings | undefined> => {
  return isNew ? await insertUserSettings(userId, payload) : await updateUserSettings(userId, payload);
};
